
import { Component, Vue, Prop } from 'vue-property-decorator'
// @ts-ignore
import JpgIcon from '@/assets/common_images/jpg.png'
// @ts-ignore
import PdfIcon from '@/assets/common_images/pdf.png'
// @ts-ignore
import WordIcon from '@/assets/common_images/word.png'
// @ts-ignore
import MusicIcon from '@/assets/common_images/music.png'
// @ts-ignore
import DefaultFile from '@/assets/common_images/default_file.png'

const iconMap = new Map([
    ['photo', JpgIcon],
    ['pdf', PdfIcon],
    ['word', WordIcon],
    ['mp3', MusicIcon]
])

/**
 * 判断文件名是否超出长度
 * @date 2021-12-16
 * @param {string} filename
 * @param {number} len = 5
 * @returns {any}
 */
export const createFilename = (filename: string, len = 5) => {
    let suffix = filename.substring(filename.lastIndexOf('.'))
    let finalName = filename
    // 没有文件后缀名的文件名
    const orginFilename = filename.replace(suffix, '')
    if (orginFilename.length >= len) {
        finalName = `${filename.substr(0, len - 2)}... ${suffix}`
    }
    return finalName
}

/**
 * @prop isSend     是否发送方，不是则为接收方
 * @prop isFile     是否文件
 * @prop fileType   文件类型 (目前支持: photo, pdf, word, mp3)
 * @prop message    消息主题内容
 * @prop avatar     头像
 * @prop label      用户标识文本（名字或者日期这些信息）
*/
@Component({
    name: 'chat-record',
    filters: {
        formatFilename(val: string) {
            return createFilename(val, 14)
        }
    }
})
export default class extends Vue {
    @Prop({ default: true }) private isSend!: boolean
    @Prop({ default: false }) private isFile!: boolean
    @Prop({ default: '' }) private fileType!: 'photo' | 'pdf' | 'word' | 'mp3'
    @Prop({ default: '' }) private message!: string
    @Prop({ default: '' }) private avatar!: string
    @Prop({ default: '' }) private label!: string
    @Prop({ default: '' }) private url!: string

    errorHandler() {
        return true
    }
    matchIcon(type: string) {
        return iconMap.get(type) || DefaultFile
    }
}
